import React, { Component } from "react";

export class Header extends Component {
  render() {
    return (
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intro-text">
                  <h1>
                    {this.props.data ? this.props.data.title1 : "Loading"}
                    <br/>
                    {this.props.data ? this.props.data.title2 : "Loading"}
                  </h1>
                  <p>
                    {this.props.data ? this.props.data.paragraph : "Loading"}
                  </p>
                  <a
                    href="https://web.chausn.vn/#/login"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-custom-green btn-lg page-scroll"
                  >
                    Đăng Nhập
                  </a>{" "}
                  
                  <a
                       href="https://web.chausn.vn/#/register"
                       target="_blank"
                       rel="noopener noreferrer"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Đăng Ký
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
